// extracted by mini-css-extract-plugin
export default {"homePage":"Home_homePage__gNdkv","section":"Home_section__uZuiO","fadeIn":"Home_fadeIn__KcmLH"};